import React, { useContext, useEffect, useState } from "react";
import Swiper from "react-id-swiper";
import HeroSliderOneSingle from "../../components/hero-slider/HeroSliderOneSingle";
import { AuthContext } from "../../common/Auth";
import NotFoundBanner from "./NotFoundBanner";
import AddIcon from "../../components/hero-slider/bannerData/AddIcon";

const HeroSliderOne = (props) => {
  const { bannersList, themeSettingsData, settingData } = useContext(AuthContext);
  const [btnBackgrndColor, setBtnBackGrndColor] = useState("");
  const [bannerTimer, setBannerTimer] = useState(null)
  const [bannerEffect, setBannerEffect] = useState("slider")
  const [VideoPlay, setVideoPlay]=useState(true)
  const [isBanner, setIsBanner]=useState(false)
  let sliderStyle = {
    fontSize: "50px"
  };

  useEffect(() => {
    if (themeSettingsData && themeSettingsData.length > 0 && settingData && settingData.length > 0) {
      const defaultColor = settingData.find(setting => setting.page === 'General')?.values?.themedefaultColor;
      if (props.setLoaded) {
        setTimeout(() => {
          props.setLoaded(true)
        }, 500)
      }
      themeSettingsData.map((i) => {
        if (i.settingsName === "bannerSettings") {
          if (i.values[0]) {
            const setColor = i.values[0].slideBtnColor !== "undefined" &&
            i.values[0].slideBtnColor ? i.values[0].slideBtnColor : "";
            const color = setColor !== "" ?
                setColor: (defaultColor && defaultColor !== "" ? defaultColor: "");
            document.documentElement.style.setProperty('--defaultSliderColor', color);
            setBtnBackGrndColor(i.values[0].btnBackgrndColor);
            const swipetimer=!!i.values[0].bannerTimer&&i.values[0].bannerTimer!==0
            ?Number(i.values[0].bannerTimer)*1000:0;
            setBannerTimer(swipetimer)
            setBannerEffect(!!i?.values[0]?.bannerTransition ? i?.values[0]?.bannerTransition : 'slider')
            setIsBanner(true)
          }
        }
      });
    }
  }, [themeSettingsData, settingData]);

  const params = bannersList.length > 1 ? {
    effect: bannerEffect,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: !!bannerTimer && bannerTimer !== 0 ? bannerTimer : 3000,
      disableOnInteraction: false,
    },
    watchSlidesVisibility: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
        <button className="antera-swiper-button swiper-button-prev ht-swiper-button-nav sliderBtn"
                style={{backgroundColor: btnBackgrndColor ? btnBackgrndColor : '#000'}}>
          <i className="pe-7s-angle-left" style={sliderStyle}/>
        </button>
    ),
    renderNextButton: () => (
        <button className="antera-swiper-button swiper-button-next ht-swiper-button-nav sliderBtn"
                style={{backgroundColor: btnBackgrndColor ? btnBackgrndColor : '#000'}}>
          <i className="pe-7s-angle-right" style={sliderStyle}/>
        </button>
    ),
    on: {
      slideChange: async function()
      {
        if(!!bannersList[this.realIndex]?.videoLink && !!bannersList[this.realIndex]?.videoStartDelay)
        {
          setVideoPlay(false)
          let delay = parseInt(bannersList[this.realIndex]?.videoStartDelay.substring(4, 5))+'000';
          await setTimeout(() => {
              setVideoPlay(true)
            }, delay);
        }
        else if(!!bannersList[this.realIndex]?.videoLink)
          setVideoPlay(true)
        else
          setVideoPlay(false)
      },
      slideChangeTransitionStart : function() {
        let $wrapperEl = this.$wrapperEl;
        let params = this.params;
        $wrapperEl.children(('.' + (params.slideClass) + '.' + (params.slideDuplicateClass)))
            .each(function () {
                let idx = this.getAttribute('data-swiper-slide-index');
                this.innerHTML = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').html();
            });
      },
      slideChangeTransitionEnd: function() {
        this.slideToLoop(this.realIndex, 0, false);
      }
    },
  } : {};

  return (
    <>
      <div className="antera-banner-container banner_default banner_spring slider-area">
      <div className="add-banner top-210">
          <AddIcon bannerId="" fromAction="FromHome" />
        </div>
        <div className="slider-active nav-style-1">
          {isBanner && 
          <Swiper {...params}>
            {bannersList && bannersList.length &&
              bannersList.map((single, key) => {
                return (
                    <HeroSliderOneSingle
                        sliderClassName="swiper-slide"
                        data={ single }
                        key={ key }
                        indexValue={ key }
                        VideoPlay={ VideoPlay }
                        bannerTimer={ bannerTimer }
                    />
                );
              })}
          </Swiper>
        }
          <NotFoundBanner />
        </div>
      </div>
    </>
  );
};

export default HeroSliderOne;
